import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const sendForgotPasswordOtp = createAsyncThunk(
    "sendForgotPasswordOtp", async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/oauth/forgot-password/`, data);
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const verifyForgotPasswordOtp = createAsyncThunk(
    "verifyForgotPasswordOtp", async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/oauth/Pverify-otp/`, data);
            const result = response;
            return result;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const resetPassword = createAsyncThunk(
    "resetPassword", async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/oauth/reset-password/`, data);
            const result = response.data;
            return result;
        } catch (error) {
            console.error("Error:", error.response.data);
            return rejectWithValue(error.response.data);
        }
    }
);

export const ForgotPasswordSlice = createSlice({
    name: "ForgotPassword",
    initialState: {
        data: {},
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(verifyForgotPasswordOtp.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(verifyForgotPasswordOtp.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        });
        builder.addCase(verifyForgotPasswordOtp.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default ForgotPasswordSlice.reducer;
